import React, { Fragment, useState, useContext, useCallback } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";
import debounce from "lodash.debounce";

import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { AddCircle, Delete } from "@mui/icons-material";
import {
  Grid,
  Button,
  DialogActions,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Slide,
  Snackbar,
  TextField,
  Alert,
  Dialog,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";

import {
  cardBodyStyle,
  ButtonExit,
  ButtonStyle0,
  blackColor,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const StyledTableRow = styled(TableRow)({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#FAFAFA",
    },
  },
});

const useStyles = makeStyles(cardBodyStyle);

export default function NewProductAdmin(props) {
  const classes = useStyles();

  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [rowsItem, setrowsItem] = useState([]);
  const [rowsPrices, setrowsPrices] = useState([]);
  const [radio, setRadio] = React.useState(0);
  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    nameProduct: "",
    descriptionPrice: "",
    price: "",
    pecialtyItem: "",
    procedure: "",
    coverage: "",
    nOrder: "",
    errorPecialtyItem: false,
    errornameProduct: false,
    errorPrice: false,
    errorDescriptionPrice: false,
    errorProcedure: false,
    errorCoverage: false,
    errorNOrder: false,
  });

  const handleChange = useCallback(
    debounce((prop, value) => {
      setValues((prevValues) => ({
        ...prevValues,
        [prop]: value,
        errorPecialtyItem: false,
        errornameProduct: false,
        errorDescriptionPrice: false,
        errorPrice: false,
        errorProcedure: false,
        errorCoverage: false,
        errorNOrder: false,
      }));

      setAlert((prevAlert) => ({
        ...prevAlert,
        openAlert: false,
      }));
    }, 10),
    []
  );

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setopenAlertSuccess(false);

    if (values.nameProduct.length === 0) {
      setValues({ ...values, errornameProduct: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "El campo Nombre del prodcuto es obligatorio.",
      });
    } else if (rowsPrices.length === 0) {
      setValues({ ...values, errorPrice: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un precio al producto.",
      });
    } else if (rowsItem.length === 0) {
      setValues({ ...values, errorPecialtyItem: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un item para el producto",
      });
    } else {
      let productID = [];
      let axiosPromises = [];
      let pricesFinaly = [];
      const errorsArray = [];

      rowsPrices.map((value) =>
        pricesFinaly.push({ name: value.descriptionPrice, price: value.price })
      );

      const insert = async () => {
        const valueData = {
          name: values.nameProduct,
          prices: JSON.stringify(pricesFinaly),
          selectIVA: radio,
          userId: UserAuth.id,
        };

        // Agregar la promesa de axios a nuestro array
        axiosPromises.push(
          axios
            .post(`${urlServices}products`, valueData, {
              headers: {
                Authorization: "Bearer " + keyAuthorization,
              },
            })
            .then((response) => {
              productID.push({
                products_id: response.data.products.id,
              });
            })
            .catch((error) => {
              console.log(error);
              errorsArray.push(valueData); // Guardar los datos que dieron error
              // setLoadersSave(false);
            })
        );
      };

      insert();

      // Esperar a que todas las promesas se resuelvan
      Promise.all(axiosPromises)
        .then(() => {
          const itemsPromises = [];

          rowsItem.forEach((data) => {
            const valuesItems = {
              productsId: productID[0].products_id,
              pecialty: data.pecialty,
              procedure: data.procedure,
              coverage: data.coverage,
              nOrder: data.nOrder,
            };

            itemsPromises.push(InsertItems(valuesItems));
          });

          // Esperar a que se completen todas las llamadas
          return Promise.allSettled(itemsPromises);
        })
        .then((results) => {
          // Aquí puedes manejar tanto los éxitos como los errores
          const errorsIntems = results.filter(
            (result) => result.value.isAxiosError
          );

          //  setErrorListPlan(errorsArray);
          // setErrorListItemsPlan(errorsIntems);

          setopenAlertSuccess(true);
          setmensaje_success("Datos guardados exitosamente.");
          props.callBackRefresh();

          setValues({
            ...values,
            nameProduct: "",
            descriptionPrice: "",
            price: "",
          });

          setRadio(0);
          setrowsPrices([]);
          setrowsItem([]);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (e.response.status === 500) {
            setMensageSystem("Error en la consulta con sel servidor.");
            setError(true);
          }
        });
    }
  };

  const InsertItems = (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${urlServices}items-product`, data, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then((response) => {
          resolve(response); // Resolvemos la promesa con la respuesta de axios
        })
        .catch((error) => {
          //reject(error); // Rechazamos la promesa con el error de axios
          resolve(error);
        });
    });
  };

  const handleAdd = () => {
    if (values.pecialtyItem.length === 0) {
      setValues({ ...values, errorPecialtyItem: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue una especialidad.",
      });
    } else if (values.procedure.length === 0) {
      setValues({ ...values, errorProcedure: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue un procedimiento.",
      });
    } else if (values.coverage.length === 0) {
      setValues({ ...values, errorCoverage: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue el Beneficio.",
      });
    } else if (values.nOrder.length === 0) {
      setValues({ ...values, errorNOrder: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue el orden que desea que se muestre.",
      });
    } else {
      setrowsItem([
        ...rowsItem,
        {
          pecialty: values.pecialtyItem,
          procedure: values.procedure,
          coverage: values.coverage,
          nOrder: values.nOrder,
        },
      ]);

      setValues({
        ...values,
        pecialtyItem: "",
        procedure: "",
        coverage: "",
        nOrder: "",
        errorPecialtyItem: false,
        errorProcedure: false,
        errorCoverage: false,
        errorNOrder: false,
      });
    }
  };

  const handleAddPrices = () => {
    if (values.descriptionPrice.length === 0) {
      setValues({ ...values, errorDescriptionPrice: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue una descripción.",
      });
    } else if (values.price.length === 0) {
      setValues({ ...values, errorPrice: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue un precio.",
      });
    } else {
      setrowsPrices([
        ...rowsPrices,
        {
          descriptionPrice: values.descriptionPrice,
          price: values.price,
        },
      ]);

      setValues({
        ...values,
        descriptionPrice: "",
        price: "",
        errorDescriptionPrice: false,
        errorPrice: false,
      });
    }
  };

  const handleRemoveClick = (i) => {
    const list = [...rowsItem];
    list.splice(i, 1);
    setrowsItem(list);
  };

  const handleRemovePriceClick = (i) => {
    const list = [...rowsPrices];
    list.splice(i, 1);
    setrowsPrices(list);
  };

  const handleRadioChange = (event) => {
    setRadio(event.target.value);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        //style={{ zIndex: 100 }}
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
                <div className={classes.titleCardFilter}>Nuevo producto</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  borderRadius: 5,
                  padding: 10,
                }}
              >
                <Grid item xs={12} sm={10}>
                  <TextField
                    name="nameProduct"
                    value={values.nameProduct}
                    error={values.errornameProduct}
                    onChange={(event) =>
                      handleChange("nameProduct", event.target.value)
                    }
                    fullWidth
                    required
                    label="Nombre producto"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={12} style={{ paddingTop: 18 }}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Agregar precios:
                  </span>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    name="descriptionPrice"
                    value={values.descriptionPrice}
                    error={values.errorDescriptionPrice}
                    onChange={(event) =>
                      handleChange("descriptionPrice", event.target.value)
                    }
                    fullWidth
                    required
                    label="Descripción"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    name="price"
                    value={values.price}
                    error={values.errorPrice}
                    onChange={(event) =>
                      handleChange("price", event.target.value)
                    }
                    fullWidth
                    required
                    label="Precio base"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                    type="number"
                    helperText="Precio sin iva."
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    <Button
                      onClick={handleAddPrices}
                      startIcon={<AddCircle />}
                      variant="contained"
                      size="small"
                    >
                      Agregar
                    </Button>
                  </center>
                </Grid>
                <Grid item xs={12} sm={12}>
                  {rowsPrices.length > 0 && (
                    <Table
                      className={classes.table}
                      size="small"
                      aria-label="a dense table"
                      style={{
                        background: "papayawhip",
                        borderRadius: 10,
                        marginTop: 10,
                      }}
                    >
                      <TableBody>
                        {rowsPrices.map((row0, i0) => {
                          return (
                            <StyledTableRow key={i0}>
                              <TableCell
                                // align="center"
                                component="th"
                                scope="row"
                                sx={{ fontSize: 12, fontWeight: "bold" }}
                              >
                                {row0.descriptionPrice}
                              </TableCell>
                              <TableCell
                                // align="center"
                                component="th"
                                scope="row"
                                sx={{ fontSize: 12 }}
                              >
                                ${parseFloat(row0.price).toFixed(2)}
                              </TableCell>
                              <TableCell
                                align="center"
                                component="th"
                                scope="row"
                              >
                                <Delete
                                  style={{
                                    cursor: "pointer",
                                    float: "right",
                                  }}
                                  onClick={() => handleRemovePriceClick(i0)}
                                />
                              </TableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  )}
                </Grid>
                <Grid item xs={12} md={4} style={{ paddingTop: 18 }}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Producto con IVA:
                  </span>
                </Grid>
                <Grid item xs={12} md={8}>
                  <RadioGroup
                    aria-labelledby="demo-error-radios"
                    name="quiz"
                    value={radio}
                    onChange={handleRadioChange}
                    row
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="SI"
                      sx={{ color: blackColor }}
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label="NO"
                      sx={{ color: blackColor }}
                    />
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} md={12} style={{ paddingTop: 8 }}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Agregar items:
                  </span>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 12 }}
                  >
                    Especialidad:
                  </span>
                  <TextField
                    name="pecialtyItem"
                    value={values.pecialtyItem}
                    error={values.errorPecialtyItem}
                    onChange={(event) =>
                      handleChange("pecialtyItem", event.target.value)
                    }
                    fullWidth
                    required
                    //label="Texto item"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 12 }}
                  >
                    Procedimiento:
                  </span>
                  <TextField
                    name="procedure"
                    value={values.procedure}
                    error={values.errorProcedure}
                    onChange={(event) =>
                      handleChange("procedure", event.target.value)
                    }
                    fullWidth
                    required
                    //label="Texto item"
                    rows={2}
                    multiline
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={9} sm={6}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 12 }}
                  >
                    Beneficio:
                  </span>
                  <TextField
                    name="coverage"
                    value={values.coverage}
                    error={values.errorCoverage}
                    onChange={(event) =>
                      handleChange("coverage", event.target.value)
                    }
                    fullWidth
                    required
                    //label="Texto item"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <span
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 12 }}
                  >
                    Orden:
                  </span>
                  <TextField
                    name="nOrder"
                    value={values.nOrder}
                    error={values.errorNOrder}
                    onChange={(event) =>
                      handleChange("nOrder", event.target.value)
                    }
                    fullWidth
                    required
                    //label="Texto item"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                    type="number"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    style={{ marginTop: 40 }}
                    onClick={handleAdd}
                    startIcon={<AddCircle />}
                    variant="contained"
                    size="small"
                  >
                    Agregar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  {rowsItem.length > 0 && (
                    <Table
                      className={classes.table}
                      size="small"
                      aria-label="a dense table"
                      style={{
                        background: "papayawhip",
                        borderRadius: 10,
                        marginTop: 10,
                      }}
                    >
                      <TableBody>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ background: "bisque", fontSize: 10 }}
                        >
                          <b>ESPECIALIDAD</b>{" "}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ background: "bisque", fontSize: 10 }}
                        >
                          <b>PROCEDIMINETO</b>{" "}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ background: "bisque", fontSize: 10 }}
                        >
                          <b>BENEFICIO</b>{" "}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ background: "bisque", fontSize: 10 }}
                        >
                          <b>ORDEN</b>{" "}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ background: "bisque", fontSize: 10 }}
                        >
                          ---
                        </TableCell>
                        <TableCell component="th" scope="row"></TableCell>
                        {rowsItem
                          .sort((a, b) => a.nOrder - b.nOrder) // Ordena de menor a mayor
                          .map((row1, i1) => {
                            return (
                              <StyledTableRow key={i1}>
                                <TableCell
                                  // align="center"
                                  component="th"
                                  scope="row"
                                  sx={{ fontSize: 12, fontWeight: "bold" }}
                                >
                                  {row1.pecialty}
                                </TableCell>
                                <TableCell
                                  // align="center"
                                  component="th"
                                  scope="row"
                                  sx={{ fontSize: 12 }}
                                >
                                  {row1.procedure}
                                </TableCell>
                                <TableCell
                                  // align="center"
                                  component="th"
                                  scope="row"
                                  sx={{ fontSize: 12 }}
                                >
                                  {row1.coverage}
                                </TableCell>
                                <TableCell
                                  // align="center"
                                  component="th"
                                  scope="row"
                                  sx={{ fontSize: 12 }}
                                >
                                  {row1.nOrder}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  component="th"
                                  scope="row"
                                >
                                  <Delete
                                    style={{
                                      cursor: "pointer",
                                      float: "right",
                                    }}
                                    onClick={() => handleRemoveClick(i1)}
                                  />
                                </TableCell>
                              </StyledTableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  )}
                </Grid>
                <Grid item xs={12} sm={12}>
                  <br></br>
                  <center>
                    <ButtonStyle0 type="submit" onClick={submitForm}>
                      Guardar
                    </ButtonStyle0>
                  </center>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    {openAlertSuccess && (
                      <Alert severity="success">{mensaje_success}</Alert>
                    )}
                  </center>
                </Grid>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
